import { api } from "@/lib/api";
import { toast } from "sonner";

// Loga um acesso (share/print) no Jornal de Eventos. Best-effort: nunca bloqueia.
export function logAcesso(payload) {
  try {
    api.post("/eventos/log-acesso", payload).catch(() => {});
  } catch (_) { /* silencioso */ }
}

// Baixa o PDF do backend e abre o menu de compartilhamento nativo do celular
// (WhatsApp, Drive, app da impressora, etc). No desktop/navegador sem suporte,
// abre o PDF em uma nova aba (comportamento anterior).
export async function sharePdf(path, filename, title = "Sistema da West") {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const blob = res.data;
    const file = new File([blob], filename, { type: "application/pdf" });

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title, text: title });
      return;
    }
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (e && e.name === "AbortError") return; // usuário fechou o menu de compartilhar
    toast.error("Não consegui preparar o PDF para compartilhar.");
  }
}

// Baixa o PDF do backend, injeta em iframe oculto e abre direto o diálogo de
// impressão do navegador (para mandar pra Zebra/impressora doméstica).
// Não afeta sharePdf. O iframe é removido após 60s.
export async function printPdf(path) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const blob = res.data;
    const url = URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (err) {
        // Fallback: abrir em nova aba
        window.open(url, "_blank");
      }
    };
    setTimeout(() => {
      try {
        document.body.removeChild(iframe);
      } catch (_) {
        // iframe já foi removido; ignora silenciosamente
      }
      URL.revokeObjectURL(url);
    }, 60000);
  } catch (e) {
    toast.error("Não consegui preparar o PDF para impressão.");
  }
}
